export const reducer=(state,action)=>{
    if(action.type=="ADD_TO_CART"){
return { ...state, cart:[...state.cart,{ ...action.payload,qty:1}]} 
    }
   
}

